export enum DeviceType {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop'
}
